import React, { useState, useEffect } from 'react';
import { handleNumericInput, handleNumericKeyDown } from '../utils/inputUtils';
import { FileText, Calendar, Save, Edit2, Eye, Trash2, RefreshCw } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { NativeSelect } from './ui/native-select';
import { ModuleInfo } from './ui/module-info';
import { usePersistedState } from '../hooks/usePersistedState';
import { toast } from 'sonner';
import axios from 'axios';
import AlteracaoEscalaDia from './AlteracaoEscalaDia';

// URL centralizado que funciona em produção mesmo com .env errado
import { getBackendUrl } from '../utils/config';
const API_URL = getBackendUrl();

const FechoTurnoTab = ({ autoOpenModal = false, onModalClose = () => {} }) => {
  const [fechos, setFechos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dataFiltro, setDataFiltro] = usePersistedState('fecho_data', new Date().toISOString().split('T')[0]);
  const [showModal, setShowModal] = useState(false);
  const [viewMode, setViewMode] = useState(false);
  const [editingFecho, setEditingFecho] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [dadosManha, setDadosManha] = useState(null);
  const [loadingDadosManha, setLoadingDadosManha] = useState(false); // Estado de carregamento
  const [turnoChanged, setTurnoChanged] = useState(false); // Rastrear se utilizador mudou turno
  const [buscaCompleta, setBuscaCompleta] = useState(false); // Rastrear se busca foi completada
  const [revendasDoTurno, setRevendasDoTurno] = useState([]); // Revendas do mesmo dia/turno
  const [revendasManha, setRevendasManha] = useState([]); // Revendas da manhã (para cálculo da tarde)
  const [colaboradores, setColaboradores] = useState([]); // Lista de colaboradores para dropdown
  const [grelhaDia, setGrelhaDia] = useState(null); // Grelha real baseada em horarios_mensais
  const [showAlteracaoEscala, setShowAlteracaoEscala] = useState(false); // Modal de alteração rápida
  
  const [formData, setFormData] = useState({
    data: new Date().toISOString().split('T')[0],
    turno: 'Manhã',
    caixa_inicial_1: 0,
    caixa_inicial_2: 0,
    caixa_inicial_3: 0,
    stock_1: 0,
    recepcao_1: 0,
    s_final_1: 0,
    stock_2: 0,
    recepcao_2: 0,
    s_final_2: 0,
    stock_3: 0,
    recepcao_3: 0,
    s_final_3: 0,
    stock_5: 0,
    recepcao_5: 0,
    s_final_5: 0,
    stock_10: 0,
    recepcao_10: 0,
    s_final_10: 0,
    stock_15: 0,
    recepcao_15: 0,
    s_final_15: 0,
    premios_master_1_15: 0,
    premios_total: 0,
    premios_reserva: 0,
    premios_exat: 0,
    vendas_manha: 0,
    vendas_total: 0,
    vendas_total_2: 0,
    v_lasser_manha: 0,
    v_lasser_total: 0,
    v_lasser_total_2: 0,
    vv_raspadinhas_1: 0,
    vv_raspadinhas_2: 0,
    vv_raspadinhas_3: 0,
    vv_raspadinhas_4: 0,
    total_expectavel: 0,
    caixa_final: 0,
    receita_reserva: 0,
    diferenca: 0,
    diferenca_reserva: 0,
    observacoes: ''
  });

  const handleOpenNewFecho = async () => {
    const novoFecho = {
      data: dataFiltro,
      turno: 'Manhã',
      caixa_inicial_1: 400,
      caixa_inicial_2: 0,
      caixa_inicial_3: 0,
      stock_1: 0,
      recepcao_1: 0,
      s_final_1: 0,
      stock_2: 0,
      recepcao_2: 0,
      s_final_2: 0,
      stock_3: 0,
      recepcao_3: 0,
      s_final_3: 0,
      stock_5: 0,
      recepcao_5: 0,
      s_final_5: 0,
      stock_10: 0,
      recepcao_10: 0,
      s_final_10: 0,
      stock_15: 0,
      recepcao_15: 0,
      s_final_15: 0,
      premios_master_1_15: 0,
      premios_total: 0,
      premios_reserva: 0,
      premios_exat: 0,
      vendas_manha: 0,
      vendas_total: 0,
      vendas_total_2: 0,
      v_lasser_manha: 0,
      v_lasser_total: 0,
      v_lasser_total_2: 0,
      vv_raspadinhas_1: 0,
      vv_raspadinhas_2: 0,
      vv_raspadinhas_3: 0,
      vv_raspadinhas_4: 0,
      total_expectavel: 0,
      caixa_final: 0,
      receita_reserva: 0,
      diferenca: 0,
      diferenca_reserva: 0,
      observacoes: ''
    };
    
    try {
      const token = localStorage.getItem('token');
      
      // Buscar configuração de caixa inicial padrão
      const configRes = await axios.get(`${API_URL}/api/configuracoes`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      novoFecho.caixa_inicial_1 = configRes.data.caixa_inicial_padrao || 400;
      
      // Buscar stock do turno (sem filtro de data, pois agora são stocks ativos)
      const response = await axios.get(`${API_URL}/api/stocks`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Procurar stock do turno selecionado (Manhã por padrão)
      let stockTurno = response.data.find(s => s.turno === novoFecho.turno);
      
      // Se não encontrar stock do turno específico, usar qualquer stock disponível
      if (!stockTurno && response.data.length > 0) {
        stockTurno = response.data[0];
        toast.warning(`Stock do turno ${novoFecho.turno} não encontrado. Usando stock ${stockTurno.turno}.`);
      }
      
      if (stockTurno) {
        novoFecho.stock_1 = stockTurno.raspadinha_1 || 0;
        novoFecho.stock_2 = stockTurno.raspadinha_2 || 0;
        novoFecho.stock_3 = stockTurno.raspadinha_3 || 0;
        novoFecho.stock_5 = stockTurno.raspadinha_5 || 0;
        novoFecho.stock_10 = stockTurno.raspadinha_10 || 0;
        novoFecho.stock_15 = stockTurno.raspadinha_15 || 0;
      } else {
        console.error('❌ [FechoTurno] Nenhum stock disponível!');
        toast.error('Nenhum stock disponível no sistema. Por favor, registe o stock primeiro.');
      }
    } catch (err) {
      console.error('Erro ao buscar dados', err);
      toast.error('Erro ao carregar stocks');
    }
    
    // Buscar revendas do dia e turno
    await buscarRevendasDoTurno(dataFiltro, novoFecho.turno);
    
    // Resetar estados ao abrir novo fecho
    setDadosManha(null);
    setLoadingDadosManha(false);
    setTurnoChanged(false); // Resetar flag de mudança de turno
    setBuscaCompleta(false); // Resetar busca completa
    
    setFormData(novoFecho);
    setShowModal(true);
    setViewMode(false);
  };

  const handleChangeData = async (novaData) => {
    
    // NÃO tocar em dadosManha aqui - deixar handleChangeTurno gerir isso
    // Apenas atualizar data e buscar revendas
    
    setFormData({...formData, data: novaData});
    await buscarRevendasDoTurno(novaData, formData.turno);
  };

  const buscarRevendasDoTurno = async (data, turno) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/revendas`, {
        params: { data },
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Filtrar revendas do mesmo turno (comparação flexível)
      const turnoNormalizado = turno.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // Remove acentos
      const revendasMesmoTurno = response.data.filter(r => {
        const turnoRevenda = (r.turno || '').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return turnoRevenda === turnoNormalizado || 
               (turnoNormalizado === 'manha' && turnoRevenda === 'manha') ||
               (turnoNormalizado === 'tarde' && turnoRevenda === 'tarde');
      });
      setRevendasDoTurno(revendasMesmoTurno);
      
      // CRÍTICO: Se for turno da Tarde, também guardar as revendas da Manhã
      // para poder subtrair os prémios das revendas da manhã no cálculo
      if (turnoNormalizado === 'tarde') {
        const revendasDaManha = response.data.filter(r => {
          const turnoRevenda = (r.turno || '').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
          return turnoRevenda === 'manha';
        });
        setRevendasManha(revendasDaManha);
      } else {
        setRevendasManha([]);
      }
    } catch (err) {
      console.error('Erro ao buscar revendas:', err);
      setRevendasDoTurno([]);
      setRevendasManha([]);
    }
  };

  const handleChangeTurno = async (turno) => {
    const dataAtual = formData.data || dataFiltro;
    
    // Atualizar turno PRIMEIRO
    setFormData({...formData, turno});
    
    // Se for Tarde, buscar dados da Manhã
    if (turno === 'Tarde' && dataAtual) {
      
      setLoadingDadosManha(true);
      setBuscaCompleta(false);
      
      // Aguardar para garantir que estados anteriores foram limpos
      await new Promise(resolve => setTimeout(resolve, 50));
      
      try {
        const token = localStorage.getItem('token');
        
        // Usar endpoint específico que não filtra por colaborador
        const response = await axios.get(`${API_URL}/api/fechos-turno/manha/${dataAtual}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        const fechoManha = response.data;
        
        if (fechoManha) {
          
          setDadosManha(fechoManha);
          setLoadingDadosManha(false);
          
          // Aguardar React processar
          await new Promise(resolve => setTimeout(resolve, 300));
          
          setBuscaCompleta(true);
          
        } else {
          setDadosManha(null);
          setLoadingDadosManha(false);
          await new Promise(resolve => setTimeout(resolve, 300));
          setBuscaCompleta(true);
        }
        
      } catch (err) {
        console.error('[DEBUG] ❌ ERRO NA API:', err);
        setDadosManha(null);
        setLoadingDadosManha(false);
        await new Promise(resolve => setTimeout(resolve, 300));
        setBuscaCompleta(true);
      }
    } else {
      setDadosManha(null);
      setLoadingDadosManha(false);
      setBuscaCompleta(false);
    }
    
    // Buscar revendas do mesmo dia e turno
    await buscarRevendasDoTurno(formData.data, turno);
    
    // Buscar stock do novo turno (sem filtro de data)
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/stocks`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      const stock = response.data.find(s => s.turno === turno);
      if (stock) {
        setFormData(prev => ({
          ...prev,
          turno,
          stock_1: stock.raspadinha_1 || 0,
          stock_2: stock.raspadinha_2 || 0,
          stock_3: stock.raspadinha_3 || 0,
          stock_5: stock.raspadinha_5 || 0,
          stock_10: stock.raspadinha_10 || 0,
          stock_15: stock.raspadinha_15 || 0
        }));
      } else {
        setFormData(prev => ({
          ...prev,
          turno,
          stock_1: 0,
          stock_2: 0,
          stock_3: 0,
          stock_5: 0,
          stock_10: 0,
          stock_15: 0
        }));
      }
    } catch (err) {
      console.error('Erro ao buscar stocks', err);
    }
  };

  useEffect(() => {
    loadFechos();
    loadGrelha();
    checkIfAdmin();
    fetchColaboradores();
  }, [dataFiltro]);

  // Re-buscar colaboradores e grelha quando a data do form mudar
  useEffect(() => {
    if (formData.data) fetchColaboradores();
  }, [formData.data]);

  // Carregar grelha baseada em horários reais (fonte verdade: horarios_mensais)
  const loadGrelha = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/turnos/grelha-dia`, {
        params: { data: dataFiltro },
        headers: { Authorization: `Bearer ${token}` }
      });
      setGrelhaDia(response.data);
    } catch (err) {
      console.error('Erro ao carregar grelha:', err);
      setGrelhaDia(null);
    }
  };

  // Buscar lista de colaboradores COM TURNO ATIVO no dia selecionado (fonte: horarios_mensais)
  const fetchColaboradores = async () => {
    try {
      const token = localStorage.getItem('token');
      const dataRef = formData.data || dataFiltro || new Date().toISOString().split('T')[0];
      
      // BLOCO 1: Fonte de verdade = horarios_mensais
      const response = await axios.get(`${API_URL}/api/turnos/colaboradores-dia`, {
        params: { data: dataRef },
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (Array.isArray(response.data) && response.data.length > 0) {
        // Transformar para formato esperado pelo dropdown
        const colabsComTurno = response.data.map(c => ({
          id: c.colaborador_id,
          nome: c.colaborador_nome,
          local: c.local,
          entrada: c.entrada,
          saida: c.saida,
          turno_classificado: c.turno_classificado,
          tipo: c.tipo,
        }));
        setColaboradores(colabsComTurno);
      } else {
        // Fallback: buscar todos os users (para datas sem horário publicado)
        const fallback = await axios.get(`${API_URL}/api/users`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const colabsAtivos = fallback.data.filter(u =>
          u.ativo !== false && (u.role === 'colaborador' || u.role === 'responsavel')
        );
        setColaboradores(colabsAtivos.map(u => ({
          id: u.id,
          nome: u.nome,
          local: null,
          entrada: null,
          saida: null,
          turno_classificado: null,
        })));
      }
    } catch (error) {
      console.error('Erro ao buscar colaboradores:', error);
      // Fallback silencioso
      try {
        const token = localStorage.getItem('token');
        const fallback = await axios.get(`${API_URL}/api/users`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const colabsAtivos = fallback.data.filter(u =>
          u.ativo !== false && (u.role === 'colaborador' || u.role === 'responsavel')
        );
        setColaboradores(colabsAtivos.map(u => ({
          id: u.id,
          nome: u.nome,
        })));
      } catch (_) {}
    }
  };

  // Abrir automaticamente o modal quando solicitado
  useEffect(() => {
    if (autoOpenModal && !showModal) {
      handleOpenNewFecho();
      // NÃO chamar onModalClose aqui - isso fecharia o modal pai
    }
  }, [autoOpenModal]);

  // Buscar dados da Manhã automaticamente quando o modal abre com turno Tarde
  useEffect(() => {
    if (showModal && formData.turno === 'Tarde' && formData.data && !dadosManha && !loadingDadosManha) {
      handleChangeTurno('Tarde');
    }
  }, [showModal, formData.turno, formData.data]);

  const checkIfAdmin = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const isAdminRole = user.role === 'admin';
    const isResponsavel = user.role === 'responsável';
    setIsAdmin(isAdminRole || isResponsavel); // Admin ou Responsável tem permissões administrativas
  };

  // Função para corrigir dados (fechos e vendas automáticas)
  const handleCorrigirDados = async () => {
    if (!window.confirm('Tem a certeza que deseja corrigir os dados?\n\nIsto irá:\n- Recalcular diferenças dos fechos de turno\n- Somar revendas às vendas automáticas\n- Recalcular pontos das raspadinhas')) {
      return;
    }
    
    const token = localStorage.getItem('token');
    
    try {
      toast.info('🔧 A corrigir fechos de turno...');
      
      // 1. Corrigir fechos de turno
      const fechosResp = await axios.post(`${API_URL}/api/fechos-turno/corrigir-calculos`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      toast.success(`✅ ${fechosResp.data.corrigidos} fechos corrigidos`);
      
      // 2. Corrigir vendas automáticas (raspadinhas)
      toast.info('🔧 A corrigir vendas de raspadinhas...');
      
      const vendasResp = await axios.post(`${API_URL}/api/vendas/corrigir-raspadinhas`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      toast.success(`✅ ${vendasResp.data.corrigidos} vendas corrigidas`);
      
      // Mostrar detalhes se houver correções
      if (vendasResp.data.detalhes && vendasResp.data.detalhes.length > 0) {
        vendasResp.data.detalhes.forEach(d => {
          toast.info(`${d.data} ${d.turno}: €${d.valor_anterior} → €${d.valor_novo} (${d.pontos} pontos)`);
        });
      }
      
      // Recarregar dados
      loadFechos();
      
    } catch (err) {
      console.error('Erro ao corrigir dados:', err);
      toast.error('❌ Erro ao corrigir dados: ' + (err.response?.data?.detail || err.message));
    }
  };

  const loadFechos = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/fechos-turno`, {
        params: { data: dataFiltro },
        headers: { Authorization: `Bearer ${token}` }
      });
      setFechos(response.data);
      setError(null);
    } catch (err) {
      setError('Erro ao carregar fechos de turno');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // VALIDAÇÃO CRÍTICA: Impedir criação de fecho da Tarde sem fecho da Manhã
    if (formData.turno === 'Tarde' && !editingFecho) {
      // Se ainda está carregando, avisar para aguardar
      if (loadingDadosManha) {
        toast.error('⚠️ Por favor aguarde enquanto buscamos os dados do turno da Manhã...');
        return;
      }
      
      // Se a busca já completou e não encontrou, bloquear
      if (buscaCompleta && !dadosManha) {
        toast.error('⚠️ Não é possível criar um fecho da Tarde sem ter o fecho da Manhã. Por favor, crie primeiro o fecho da Manhã para a data ' + formData.data);
        return;
      }
      
      // Se a busca ainda não completou (usuário clicou muito rápido), tentar buscar agora
      if (!buscaCompleta) {
        toast.error('⚠️ Por favor aguarde - verificando se existe fecho da Manhã...');
        await handleChangeTurno('Tarde');
        return;
      }
    }
    
    try {
      const token = localStorage.getItem('token');
      
      // Para ambos os turnos, calcular caixa_final e diferenca automaticamente
      let dataToSubmit = { ...formData };
      
      // Calcular Total Expectável
      const totalVendidas = [1, 2, 3, 5, 10, 15].reduce((total, valor) => {
        const stock = formData[`stock_${valor}`] || 0;
        const recepcao = formData[`recepcao_${valor}`] || 0;
        const sFinal = formData[`s_final_${valor}`] || 0;
        const vendidas = stock + recepcao - sFinal;
        return total + (vendidas * valor);
      }, 0);
      let vendas = formData.premios_master_1_15 || 0;
      let premios = formData.premios_total || 0;
      
      // Calcular dinheiro de revendas E total de raspadinhas da revenda
      let totalRaspadinhasRevenda = 0;
      const dinheiroRevendas = revendasDoTurno.reduce((total, revenda) => {
        const valorRaspadinhas = (
          (revenda.raspadinha_1 || 0) * 1 +
          (revenda.raspadinha_2 || 0) * 2 +
          (revenda.raspadinha_3 || 0) * 3 +
          (revenda.raspadinha_5 || 0) * 5 +
          (revenda.raspadinha_10 || 0) * 10 +
          (revenda.raspadinha_15 || 0) * 15
        );
        totalRaspadinhasRevenda += valorRaspadinhas; // Somar total de raspadinhas da revenda
        const comissaoRevendedor = valorRaspadinhas * 0.05; // Revendedor fica com 5%
        const dinheiroLoja = valorRaspadinhas - comissaoRevendedor; // Loja recebe 95%
        return total + dinheiroLoja;
      }, 0);
      
      // CRÍTICO: Se for Tarde e tiver dados da Manhã, SUBTRAIR vendas e prémios da manhã
      // Isto dá os valores APENAS da Tarde
      if (formData.turno === 'Tarde' && dadosManha) {
        const vendasManha = dadosManha.premios_master_1_15 || 0;
        const premiosManha = dadosManha.premios_total || 0;
        vendas = vendas - vendasManha; // Vendas apenas da Tarde
        premios = premios - premiosManha; // Prémios apenas da Tarde
      }
      
      const caixaInicial = formData.caixa_inicial_1 || 0;
      const totalExpectavel = caixaInicial + totalVendidas + vendas - premios + dinheiroRevendas; // SOMAR dinheiro revendas
      
      // IMPORTANTE: Total de raspadinhas vendidas INCLUINDO revendas (para objetivos)
      const totalRaspadinhasComRevenda = totalVendidas + totalRaspadinhasRevenda;
      dataToSubmit.total_raspadinhas_vendidas = totalRaspadinhasComRevenda; // Enviar para backend
      dataToSubmit.total_raspadinhas_revenda = totalRaspadinhasRevenda; // Guardar separadamente para referência
      
      // Caixa Final = Caixa Atual (não precisa calcular, já está em caixa_inicial_2)
      dataToSubmit.caixa_final = formData.caixa_inicial_2;
      
      // Diferença = Caixa Atual - Total Expectável
      dataToSubmit.diferenca = formData.caixa_inicial_2 - totalExpectavel;
      
      if (editingFecho) {
        await axios.put(
          `${API_URL}/api/fechos-turno/${editingFecho.id}`,
          dataToSubmit,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        await axios.post(
          `${API_URL}/api/fechos-turno`,
          dataToSubmit,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
      
      setShowModal(false);
      setViewMode(false);
      resetForm();
      loadFechos();
      loadGrelha();
      
      // Aguardar um momento para o backend processar a venda automática
      setTimeout(async () => {
        try {
          // Buscar pontos da venda automática criada
          const vendasResponse = await axios.get(
            `${API_URL}/api/vendas?data=${dataToSubmit.data}&seccao=Raspadinhas&origem=fecho_turno`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          
          let pontosGanhos = 0;
          if (vendasResponse.data && vendasResponse.data.length > 0) {
            // Procurar a venda para esta data (qualquer formato de turno)
            // Backend pode salvar como "Fecho Turno.MANHA", "Fecho Manhã", etc.
            const vendaColaborador = vendasResponse.data.find(v => 
              v.data === dataToSubmit.data && 
              v.origem === 'fecho_turno'
            );
            
            if (vendaColaborador) {
              pontosGanhos = vendaColaborador.pontos_ganhos || 0;
            } else {
            }
          }
          
          // Mensagem de sucesso padrão
          toast.success(editingFecho ? '✅ Fecho atualizado com sucesso!' : '✅ Fecho criado com sucesso!');
          
          // Mensagem de PONTOS - GRANDE e MUITO VISÍVEL
          if (pontosGanhos > 0) {
            const mensagemPontos = pontosGanhos === 1 
              ? '🎉 PARABÉNS! Ganhou 1 PONTO nas Raspadinhas! 🏆'
              : `🎉 PARABÉNS! Ganhou ${pontosGanhos} PONTOS nas Raspadinhas! 🏆`;
            
            // Toast grande e chamativo
            setTimeout(() => {
              toast.success(mensagemPontos, {
                duration: 10000,  // 10 segundos bem visível
                style: {
                  background: '#10b981',
                  color: 'white',
                  fontSize: '20px',
                  fontWeight: 'bold',
                  padding: '24px',
                  borderRadius: '12px',
                  boxShadow: '0 10px 40px rgba(16, 185, 129, 0.4)',
                  border: '3px solid #059669'
                }
              });
            }, 800);
          }
        } catch (err) {
          toast.success(editingFecho ? 'Fecho atualizado com sucesso!' : 'Fecho criado com sucesso!');
        }
      }, 500);
    } catch (err) {
      const errorDetail = err.response?.data?.detail || 'Erro ao salvar fecho de turno';
      setError(errorDetail);
      
      // Se o erro é de duplicação, sugerir editar o fecho existente
      if (errorDetail.includes('Já existe fecho')) {
        toast.error('Já existe um fecho para esta data e turno. Por favor, edite o fecho existente ou elimine-o primeiro.');
      } else {
        toast.error(errorDetail);
      }
    }
  };

  const handleView = async (fecho) => {
    // Mostrar loading enquanto carrega dados
    setLoadingDadosManha(true);
    
    // Buscar dados da Manhã se for Tarde
    if (fecho.turno === 'Tarde') {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API_URL}/api/fechos-turno`, {
          params: { data: fecho.data },
          headers: { Authorization: `Bearer ${token}` }
        });
        
        const fechoManha = response.data.find(f => f.turno === 'Manhã');
        
        if (fechoManha) {
          setDadosManha(fechoManha);
        } else {
          setDadosManha(null);
        }
      } catch (err) {
        console.error('Erro ao buscar fecho da manhã', err);
        setDadosManha(null);
      }
    } else {
      // Se for Manhã, limpar dados da manhã anterior
      setDadosManha(null);
    }
    
    // Buscar revendas do turno - AGUARDAR carregamento completo
    await buscarRevendasDoTurno(fecho.data, fecho.turno);
    
    // Marcar busca como completa
    setBuscaCompleta(true);
    
    // Configurar estado do formulário e abrir modal por último
    setEditingFecho(fecho);
    setFormData(fecho);
    setViewMode(true);
    setLoadingDadosManha(false);
    setShowModal(true);
  };

  const handleEdit = async (fecho) => {
    // Mostrar loading enquanto carrega dados
    setLoadingDadosManha(true);
    
    // Se for turno da Tarde, buscar dados da Manhã ANTES de abrir o modal
    if (fecho.turno === 'Tarde') {
      
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API_URL}/api/fechos-turno`, {
          params: { data: fecho.data },
          headers: { Authorization: `Bearer ${token}` }
        });
        
        const fechoManha = response.data.find(f => f.turno === 'Manhã');
        
        if (fechoManha) {
          setDadosManha(fechoManha);
        } else {
          setDadosManha(null);
        }
      } catch (err) {
        console.error('Erro ao buscar fecho da manhã', err);
        setDadosManha(null);
      }
    } else {
      // Se for Manhã, limpar dados da manhã anterior
      setDadosManha(null);
    }
    
    // Buscar revendas do turno - AGUARDAR carregamento completo
    await buscarRevendasDoTurno(fecho.data, fecho.turno);
    
    // Marcar busca como completa
    setBuscaCompleta(true);
    
    // Configurar estado do formulário e abrir modal por último
    setEditingFecho(fecho);
    setFormData(fecho);
    setViewMode(false);
    setLoadingDadosManha(false);
    setShowModal(true);
  };

  const handleDelete = async (fechoId) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API_URL}/api/fechos-turno/${fechoId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Fecho eliminado com sucesso!');
      loadFechos();
      loadGrelha();
    } catch (err) {
      toast.error('Erro ao eliminar fecho de turno');
      setError('Erro ao eliminar fecho de turno');
    }
  };

  const resetForm = () => {
    setEditingFecho(null);
    setFormData({
      data: dataFiltro,
      turno: 'Manhã',
      caixa_inicial_1: 0,
      caixa_inicial_2: 0,
      caixa_inicial_3: 0,
      stock_1: 0,
      recepcao_1: 0,
      s_final_1: 0,
      stock_2: 0,
      recepcao_2: 0,
      s_final_2: 0,
      stock_3: 0,
      recepcao_3: 0,
      s_final_3: 0,
      stock_5: 0,
      recepcao_5: 0,
      s_final_5: 0,
      stock_10: 0,
      recepcao_10: 0,
      s_final_10: 0,
      stock_15: 0,
      recepcao_15: 0,
      s_final_15: 0,
      premios_master_1_15: 0,
      premios_total: 0,
      premios_reserva: 0,
      premios_exat: 0,
      vendas_manha: 0,
      vendas_total: 0,
      vendas_total_2: 0,
      v_lasser_manha: 0,
      v_lasser_total: 0,
      v_lasser_total_2: 0,
      vv_raspadinhas_1: 0,
      vv_raspadinhas_2: 0,
      vv_raspadinhas_3: 0,
      vv_raspadinhas_4: 0,
      total_expectavel: 0,
      caixa_final: 0,
      receita_reserva: 0,
      diferenca: 0,
      diferenca_reserva: 0,
      observacoes: ''
    });
  };

  // Cálculos automáticos
  const calcularRaspVendidas = (valor) => {
    const stock = formData[`stock_${valor}`] || 0;
    const recepcao = formData[`recepcao_${valor}`] || 0;
    const sFinal = formData[`s_final_${valor}`] || 0;
    return stock + recepcao - sFinal;
  };

  const calcularTotalRasp = (valor) => {
    const vendidas = calcularRaspVendidas(valor);
    return vendidas * valor;
  };

  if (loading) return <div className="text-center py-8">Carregando...</div>;

  // Se autoOpenModal é true, renderizar APENAS o modal, sem a lista
  if (autoOpenModal) {
    return (
      <div>
        {showModal && (
          <FechoTurnoModal
            formData={formData}
            setFormData={setFormData}
            onSubmit={handleSubmit}
            onClose={() => { 
              setShowModal(false); 
              setViewMode(false); 
              resetForm(); 
              setDadosManha(null); 
              setRevendasDoTurno([]); 
              setTurnoChanged(false); 
              setBuscaCompleta(false);
              onModalClose(); // Notificar o componente pai
            }}
            viewMode={viewMode}
            editingFecho={editingFecho}
            calcularRaspVendidas={calcularRaspVendidas}
            calcularTotalRasp={calcularTotalRasp}
            handleChangeTurno={handleChangeTurno}
            handleChangeData={handleChangeData}
            isAdmin={isAdmin}
            dadosManha={dadosManha}
            loadingDadosManha={loadingDadosManha}
            buscaCompleta={buscaCompleta}
            revendasDoTurno={revendasDoTurno}
            colaboradores={colaboradores}
          />
        )}
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* ModuleInfo - Ajuda contextual */}
      <div className="flex items-center gap-2">
        <ModuleInfo
          descricao="Formulario de fecho de turno diario. Regista caixa inicial, stock e vendas de raspadinhas (6 escaloes), premios, revendas e caixa final. Calcula automaticamente a diferenca entre o valor esperado e o real."
          dados="Stocks de /api/stocks, revendas de /api/revendas, configuracoes de /api/configuracoes. Dados da manha buscados automaticamente de /api/fechos-turno/manha quando o turno e Tarde."
          calculo="Vendas raspadinhas = (stock + rececao - stock final) x valor unitario por escalao. Total expectavel = caixa inicial + vendas raspadinhas + vendas gerais - premios + comissao revendas. Diferenca = caixa atual - total expectavel."
          legendas="Turno Manha = valores absolutos do dia. Turno Tarde = valores acumulados menos os da manha. Caixa inicial padrao = 400 EUR. Botao 'Corrigir Dados' recalcula fechos e raspadinhas."
        />
      </div>
      {/* Header */}
      <Card className="bg-gradient-card border-primary/20">
        <CardContent className="p-4">
          <div className="flex items-center justify-between flex-wrap gap-4">
            <div className="flex items-center gap-4">
              <Calendar className="h-5 w-5 text-primary" />
              <span className="font-semibold">Data:</span>
              <input
                type="date"
                value={dataFiltro}
                onChange={(e) => setDataFiltro(e.target.value)}
                className="px-3 py-2 border rounded-md bg-background"
              />
            </div>
            <div className="flex gap-2">
              {isAdmin && (
                <Button 
                  onClick={() => setShowAlteracaoEscala(true)}
                  variant="outline"
                  className="border-amber-500 text-amber-600 hover:bg-amber-50"
                  data-testid="btn-alterar-escala-dia"
                >
                  <RefreshCw className="h-4 w-4 mr-2" />
                  Alterar Escala do Dia
                </Button>
              )}
              <Button 
                onClick={handleOpenNewFecho}
                className="bg-primary hover:bg-primary/90"
              >
                <FileText className="h-4 w-4 mr-2" />
                Novo Fecho de Jogos
              </Button>
              
              {isAdmin && (
                <Button 
                  onClick={handleCorrigirDados}
                  variant="outline"
                  className="border-orange-500 text-orange-500 hover:bg-orange-500/10"
                >
                  🔧 Corrigir Dados
                </Button>
              )}
            </div>
          </div>
        </CardContent>
      </Card>

      {error && (
        <div className="bg-destructive/10 border border-destructive text-destructive px-4 py-3 rounded">
          {error}
        </div>
      )}

      {/* Grelha de Turnos — construída a partir do horário REAL (horarios_mensais + overrides) */}
      {grelhaDia && (grelhaDia.turnos?.["Manhã"]?.length > 0 || grelhaDia.turnos?.["Tarde"]?.length > 0) ? (
        <div className="space-y-4">
          {/* Indicador de overrides activos */}
          {grelhaDia.total_overrides > 0 && (
            <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-amber-50 border border-amber-200 text-amber-700 text-sm" data-testid="overrides-indicator">
              <RefreshCw className="h-4 w-4" />
              <span className="font-medium">{grelhaDia.total_overrides} alteração(ões) aplicada(s) hoje</span>
              <Button size="sm" variant="ghost" className="h-6 px-2 text-xs ml-auto" onClick={() => setShowAlteracaoEscala(true)}>
                Ver / Editar
              </Button>
            </div>
          )}
          {["Manhã", "Tarde"].map(turnoNome => {
            const turnos = grelhaDia.turnos?.[turnoNome] || [];
            if (turnos.length === 0) return null;
            return (
              <Card key={turnoNome} data-testid={`grelha-${turnoNome.toLowerCase().replace('ã', 'a')}`}>
                <CardHeader className="pb-2">
                  <CardTitle className="text-base flex items-center gap-2">
                    <span className={`w-3 h-3 rounded-full ${turnoNome === 'Manhã' ? 'bg-amber-400' : 'bg-indigo-400'}`} />
                    Turno {turnoNome}
                    <span className="text-xs font-normal text-muted-foreground ml-2">({turnos.length} colaboradores)</span>
                  </CardTitle>
                </CardHeader>
                <CardContent className="pt-0">
                  <div className="space-y-2">
                    {turnos.map((item, idx) => (
                      <div
                        key={`${item.colaborador_id}-${idx}`}
                        data-testid={`turno-item-${item.colaborador_id}`}
                        className={`flex items-center justify-between gap-3 rounded-lg border px-3 py-2 text-sm ${
                          item.estado === 'fecho_ok' ? 'bg-emerald-50 border-emerald-200' :
                          item.estado === 'fecho_errado' ? 'bg-red-50 border-red-200' :
                          'bg-white border-gray-200'
                        }`}
                      >
                        <div className="flex items-center gap-3 min-w-0">
                          <div className={`w-2 h-2 rounded-full shrink-0 ${
                            item.estado === 'fecho_ok' ? 'bg-emerald-500' :
                            item.estado === 'fecho_errado' ? 'bg-red-500' :
                            'bg-gray-300'
                          }`} />
                          <div className="min-w-0">
                            <p className="font-semibold truncate" data-testid={`turno-nome-${item.colaborador_id}`}>
                              {item.colaborador_nome}
                              {item.override && <span className="ml-1.5 text-xs font-normal text-amber-600 bg-amber-100 px-1.5 py-0.5 rounded-full">alterado</span>}
                              {item.turno_extra && <span className="ml-1.5 text-xs font-normal text-emerald-600 bg-emerald-100 px-1.5 py-0.5 rounded-full">extra</span>}
                            </p>
                            <p className="text-xs text-muted-foreground">
                              {item.local} &middot; {item.entrada}–{item.saida}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center gap-2 shrink-0">
                          {item.fecho_existente ? (
                            <>
                              <span className="text-xs px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700 font-medium" data-testid={`fecho-status-${item.colaborador_id}`}>
                                Fecho OK
                              </span>
                              <Button size="sm" variant="outline" className="h-7 px-2" onClick={() => {
                                const fecho = fechos.find(f => f.id === item.fecho_existente.id);
                                if (fecho) handleView(fecho);
                              }}>
                                <Eye className="h-3 w-3" />
                              </Button>
                              <Button size="sm" variant="outline" className="h-7 px-2" onClick={() => {
                                const fecho = fechos.find(f => f.id === item.fecho_existente.id);
                                if (fecho) handleEdit(fecho);
                              }}>
                                <Edit2 className="h-3 w-3" />
                              </Button>
                            </>
                          ) : (
                            <Button
                              size="sm"
                              className="h-7 px-3 bg-primary hover:bg-primary/90 text-xs"
                              data-testid={`btn-criar-fecho-${item.colaborador_id}`}
                              onClick={() => {
                                setFormData(prev => ({
                                  ...prev,
                                  data: dataFiltro,
                                  turno: turnoNome,
                                  colaborador_id: item.colaborador_id,
                                  colaborador_nome: item.colaborador_nome,
                                }));
                                handleChangeTurno(turnoNome);
                                setEditingFecho(null);
                                setViewMode(false);
                                setShowModal(true);
                              }}
                            >
                              <FileText className="h-3 w-3 mr-1" />
                              Criar Fecho
                            </Button>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            );
          })}

          {/* Fechos Órfãos (não correspondem ao horário) */}
          {grelhaDia.diagnostico?.fechos_orfaos?.length > 0 && (
            <Card className="border-red-200 bg-red-50/50" data-testid="fechos-orfaos">
              <CardHeader className="pb-2">
                <CardTitle className="text-base text-red-700 flex items-center gap-2">
                  <span className="w-3 h-3 rounded-full bg-red-400" />
                  Fechos sem turno válido ({grelhaDia.diagnostico.fechos_orfaos.length})
                </CardTitle>
              </CardHeader>
              <CardContent className="pt-0">
                <p className="text-xs text-red-600 mb-2">Estes fechos não correspondem a nenhum turno no horário real do dia. Podem ser de colaboradores de folga ou com turno errado.</p>
                <div className="space-y-1">
                  {grelhaDia.diagnostico.fechos_orfaos.map((orfao, idx) => (
                    <div key={idx} className="flex items-center justify-between text-sm px-3 py-1.5 rounded border border-red-200 bg-white">
                      <span className="font-medium text-red-800">{orfao.colaborador_nome} — {orfao.turno}</span>
                      <div className="flex items-center gap-2">
                        <span className="text-xs text-red-500">{orfao.problema?.substring(0, 60)}</span>
                        {isAdmin && (
                          <Button size="sm" variant="destructive" className="h-6 px-2 text-xs" onClick={() => {
                            if (window.confirm(`Eliminar fecho órfão de ${orfao.colaborador_nome}?`)) handleDelete(orfao.id);
                          }}>
                            <Trash2 className="h-3 w-3" />
                          </Button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          )}
        </div>
      ) : (
        /* Fallback: Lista tradicional de fechos (para datas sem horário publicado) */
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {fechos.length === 0 ? (
            <Card className="col-span-2">
              <CardContent className="p-8 text-center text-muted-foreground">
                <FileText className="h-12 w-12 mx-auto mb-4 opacity-50" />
                <p>Nenhum fecho de turno registado nesta data</p>
                {!grelhaDia && <p className="text-xs mt-1">Sem horário publicado — a carregar fechos existentes</p>}
              </CardContent>
            </Card>
          ) : (
            fechos.map((fecho) => (
              <Card key={fecho.id} className="hover:shadow-lg transition-shadow">
                <CardHeader>
                  <div className="flex items-center justify-between">
                    <div>
                      <CardTitle className="text-lg">Turno {fecho.turno}</CardTitle>
                      <p className="text-sm text-muted-foreground mt-1">
                        {new Date(fecho.data + 'T00:00:00').toLocaleDateString('pt-PT')}
                      </p>
                    </div>
                    <div className="flex gap-2">
                      <Button size="sm" variant="outline" onClick={() => handleView(fecho)}>
                        <Eye className="h-4 w-4" />
                      </Button>
                      <Button size="sm" variant="outline" onClick={() => handleEdit(fecho)}>
                        <Edit2 className="h-4 w-4" />
                      </Button>
                      {isAdmin && (
                        <Button 
                          size="sm" 
                          variant="destructive" 
                          onClick={() => {
                            if (window.confirm('Tem certeza que deseja eliminar este fecho de turno?')) {
                              handleDelete(fecho.id);
                            }
                          }}
                        >
                          <Trash2 className="h-4 w-4" />
                        </Button>
                      )}
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-muted-foreground">Colaborador:</span>
                      <span className="font-semibold">{fecho.colaborador_nome}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-muted-foreground">Caixa Final:</span>
                      <span className="font-semibold text-primary">{'\u20AC'}{fecho.caixa_final?.toFixed(2) || '0.00'}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-muted-foreground">Diferença:</span>
                      <span className={`font-semibold ${(fecho.diferenca || 0) >= 0 ? 'text-success' : 'text-destructive'}`}>
                        {'\u20AC'}{(fecho.diferenca || 0).toFixed(2)}
                      </span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))
          )}
        </div>
      )}

      {/* Modal - Continua no próximo bloco */}
      {showModal && (
        <FechoTurnoModal
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleSubmit}
          onClose={() => { setShowModal(false); setViewMode(false); resetForm(); setDadosManha(null); setRevendasDoTurno([]); setTurnoChanged(false); setBuscaCompleta(false); }}
          viewMode={viewMode}
          editingFecho={editingFecho}
          calcularRaspVendidas={calcularRaspVendidas}
          calcularTotalRasp={calcularTotalRasp}
          handleChangeTurno={handleChangeTurno}
          handleChangeData={handleChangeData}
          isAdmin={isAdmin}
          dadosManha={dadosManha}
          loadingDadosManha={loadingDadosManha}
          buscaCompleta={buscaCompleta}
          revendasDoTurno={revendasDoTurno}
          colaboradores={colaboradores}
        />
      )}

      {/* Modal de Alteração Rápida da Escala */}
      <AlteracaoEscalaDia
        data={dataFiltro}
        grelhaDia={grelhaDia}
        colaboradores={colaboradores}
        isOpen={showAlteracaoEscala}
        onClose={() => setShowAlteracaoEscala(false)}
        onAlteracaoSaved={() => {
          loadGrelha();
          fetchColaboradores();
        }}
      />
    </div>
  );
};

// Componente para linha de raspadinha (definido fora para evitar re-renderizações)
const RaspadinhaRow = React.memo(({ valor, formData, updateField, calcularRaspVendidas, calcularTotalRasp, viewMode }) => {
  // Para cálculos, converter para número
  const stock = parseFloat(formData[`stock_${valor}`]) || 0;
  const recepcao = parseFloat(formData[`recepcao_${valor}`]) || 0;
  const sFinal = parseFloat(formData[`s_final_${valor}`]) || 0;
  
  const sInicial = stock + recepcao;
  const vendidas = calcularRaspVendidas(valor);
  const total = calcularTotalRasp(valor);

  return (
    <div className="grid grid-cols-7 gap-3 items-center border-b border-border pb-2">
      <div className="font-semibold">{valor}€</div>
      <input
        type="text"
        value={stock}
        className="px-2 py-2 border rounded text-sm bg-muted/50 w-20"
        disabled
        readOnly
        title="Stock vem da tabela de Stocks do Admin"
      />
      <input
        type="text"
        value={formData[`recepcao_${valor}`] ?? 0}
        onChange={(e) => updateField(`recepcao_${valor}`, e.target.value)}
        onBlur={(e) => updateField(`recepcao_${valor}`, parseFloat(e.target.value) || 0)}
        className="px-3 py-2 border rounded text-sm bg-background w-20"
        disabled={viewMode}
        inputMode="decimal"
      />
      <div className="px-2 py-1 bg-muted rounded text-sm text-center">{sInicial}</div>
      <input
        type="text"
        value={formData[`s_final_${valor}`] ?? 0}
        onChange={(e) => updateField(`s_final_${valor}`, e.target.value)}
        onBlur={(e) => updateField(`s_final_${valor}`, parseFloat(e.target.value) || 0)}
        className="px-3 py-2 border rounded text-sm bg-background w-20"
        disabled={viewMode}
        inputMode="decimal"
      />
      <div className="px-2 py-1 bg-success/10 text-success rounded text-sm text-center font-semibold">{vendidas}</div>
      <div className="px-2 py-1 bg-accent/10 text-accent rounded text-sm text-center font-semibold">€{total.toFixed(2)}</div>
    </div>
  );
});

// Componente Modal separado para melhor organização
const FechoTurnoModal = ({ formData, setFormData, onSubmit, onClose, viewMode, editingFecho, calcularRaspVendidas, calcularTotalRasp, handleChangeTurno, handleChangeData, isAdmin, dadosManha, loadingDadosManha, buscaCompleta, revendasDoTurno, colaboradores = [] }) => {
  // Helper para selecionar todo o texto quando foca num input numérico
  const handleFocusSelect = (e) => {
    e.target.select();
    // Se o valor é 0, limpar o campo para facilitar a escrita
    if (e.target.value === '0' || e.target.value === '0.00') {
      setTimeout(() => {
        e.target.value = '';
        e.target.dispatchEvent(new Event('input', { bubbles: true }));
      }, 0);
    }
  };
  
  // Helper para aceitar vírgula como separador decimal
  const handleKeyDown = (e) => {
    // Converter vírgula do teclado numérico em ponto
    if (e.key === ',' || e.key === 'Decimal') {
      e.preventDefault();
      const input = e.target;
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const value = input.value;
      
      // Inserir ponto no lugar da vírgula
      const newValue = value.substring(0, start) + '.' + value.substring(end);
      input.value = newValue;
      input.setSelectionRange(start + 1, start + 1);
      
      // Disparar evento de input para atualizar o React state
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  };
  
  const updateField = (field, value) => {
    // Para campos numéricos, permitir apenas números, ponto e vírgula
    let processedValue = value;
    if (typeof value === 'string') {
      // Substituir vírgula por ponto
      processedValue = value.replace(/,/g, '.');
      
      // Remover caracteres inválidos (manter apenas números e um ponto)
      processedValue = processedValue.replace(/[^0-9.]/g, '');
      
      // Garantir que só há um ponto decimal
      const parts = processedValue.split('.');
      if (parts.length > 2) {
        processedValue = parts[0] + '.' + parts.slice(1).join('');
      }
      
      // Remover zeros à esquerda desnecessários (mas manter "0" e "0.x")
      if (processedValue.match(/^0+[1-9]/)) {
        processedValue = processedValue.replace(/^0+/, '');
      }
    }
    setFormData({...formData, [field]: processedValue});
  };

  return (
    <div 
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 overflow-y-auto" 
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div 
        className="bg-card rounded-lg max-w-6xl w-full my-8 relative z-50" 
        onClick={(e) => e.stopPropagation()}
        onMouseMove={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="p-6 border-b border-border sticky top-0 bg-card z-10">
          <h2 className="text-xl font-semibold flex items-center gap-2">
            <FileText className="h-5 w-5" />
            {viewMode ? 'Visualizar' : editingFecho ? 'Editar' : 'Novo'} Fecho de Jogos
          </h2>
        </div>
        
        <form onSubmit={onSubmit} className="p-6 space-y-6 max-h-[70vh] overflow-y-auto">
          {/* Data, Turno e Colaborador */}
          <div className="grid grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium mb-2">Data</label>
              <input
                type="date"
                value={formData.data}
                onChange={(e) => handleChangeData ? handleChangeData(e.target.value) : updateField('data', e.target.value)}
                className="w-full px-3 py-2 border rounded-md bg-background"
                disabled={viewMode}
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-2">Turno</label>
              <select
                value={formData.turno}
                onChange={(e) => {
                  handleChangeTurno(e.target.value);
                }}
                className="w-full px-3 py-2 border rounded-md bg-background"
                disabled={viewMode || editingFecho}
                required
              >
                <option value="Manhã">Manhã</option>
                <option value="Tarde">Tarde</option>
              </select>
              {!editingFecho && (
                <p className="text-xs text-muted-foreground mt-1">
                  Stock será carregado automaticamente
                </p>
              )}
            </div>
            {/* Colaborador — visível para todos, baseado em horarios_mensais */}
            <div>
              <label className="block text-sm font-medium mb-2">
                Colaborador do Turno
              </label>
              <select
                value={formData.colaborador_id || ''}
                onChange={(e) => {
                  const selectedColab = colaboradores.find(c => c.id === e.target.value);
                  setFormData({
                    ...formData,
                    colaborador_id: e.target.value,
                    colaborador_nome: selectedColab ? selectedColab.nome : ''
                  });
                }}
                className="w-full px-3 py-2 border rounded-md bg-background"
                disabled={viewMode}
                required
                data-testid="select-colaborador-turno"
              >
                <option value="">Selecionar colaborador</option>
                {colaboradores
                  .filter(c => {
                    // Filtrar pelo turno selecionado se tiver info de turno
                    if (!c.turno_classificado) return true;
                    return c.turno_classificado === formData.turno;
                  })
                  .map((colab) => (
                    <option key={colab.id} value={colab.id}>
                      {colab.nome}{colab.local ? ` — ${colab.local}` : ''}{colab.entrada ? ` (${colab.entrada}–${colab.saida})` : ''}
                    </option>
                  ))
                }
              </select>
              {colaboradores.some(c => c.turno_classificado) ? (
                <p className="text-xs text-emerald-600 mt-1">
                  A mostrar apenas colaboradores com turno {formData.turno} hoje
                </p>
              ) : (
                <p className="text-xs text-amber-600 mt-1">
                  Sem horário publicado — a mostrar todos os colaboradores
                </p>
              )}
            </div>
          </div>

          {/* Caixa Inicial */}
          <Card>
            <CardHeader>
              <CardTitle className="text-base">Caixa Inicial</CardTitle>
              {!isAdmin && (
                <p className="text-xs text-muted-foreground">
                  * Caixa Inicial e Caixa Real são calculados automaticamente (não editável)
                </p>
              )}
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm mb-2 font-semibold">Caixa Inicial</label>
                  <input
                    type="text"
                    
                    value={formData.caixa_inicial_1}
                    onChange={(e) => updateField('caixa_inicial_1', e.target.value)}
                    onBlur={(e) => updateField('caixa_inicial_1', parseFloat(e.target.value) || 0)}
                    className={`w-full px-3 py-2 border rounded-md font-bold ${
                      isAdmin ? 'bg-background' : 'bg-warning/10 text-warning cursor-not-allowed'
                    }`}
                    disabled={!isAdmin || viewMode}
                    readOnly={!isAdmin}
                    inputMode="decimal"
                    placeholder="0.00"
                    title={isAdmin ? "Editável pelo Admin" : "Valor padrão definido pelo Admin"}
                  />
                </div>
                <div>
                  <label className="block text-sm mb-2 font-semibold">Caixa Atual</label>
                  <input
                    type="text"
                    
                    value={formData.caixa_inicial_2}
                    onChange={(e) => updateField('caixa_inicial_2', e.target.value)}
                    onBlur={(e) => updateField('caixa_inicial_2', parseFloat(e.target.value) || 0)}
                    className="w-full px-3 py-2 border rounded-md bg-background font-bold"
                    disabled={viewMode}
                    inputMode="decimal"
                    placeholder="0.00"
                  />
                </div>
                <div>
                  <label className="block text-sm mb-2 font-semibold">Caixa Real</label>
                  <input
                    type="text"
                    
                    value={(formData.caixa_inicial_2 - formData.caixa_inicial_1).toFixed(2)}
                    className="w-full px-3 py-2 border rounded-md bg-warning/10 text-warning font-bold cursor-not-allowed"
                    disabled
                    readOnly
                    title="Calculado: Caixa Atual - Caixa Inicial"
                  />
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Raspadinhas */}
          <Card>
            <CardHeader>
              <CardTitle className="text-base">Raspadinhas</CardTitle>
              {!editingFecho && (
                <p className="text-xs text-muted-foreground">
                  * Stock carregado automaticamente da tabela de Stocks (Admin)
                </p>
              )}
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-7 gap-3 text-xs font-semibold mb-2">
                <div>Valor</div>
                <div>Stock</div>
                <div>Recepção</div>
                <div>S.Inicial</div>
                <div>S.Final</div>
                <div>Vendidas</div>
                <div>Total €</div>
              </div>
              <div className="space-y-3">
                {[1, 2, 3, 5, 10, 15].map(valor => (
                  <RaspadinhaRow 
                    key={valor} 
                    valor={valor}
                    formData={formData}
                    updateField={updateField}
                    calcularRaspVendidas={calcularRaspVendidas}
                    calcularTotalRasp={calcularTotalRasp}
                    viewMode={viewMode}
                  />
                ))}
              </div>
              
              {/* Totais das Raspadinhas */}
              <div className="mt-4 pt-4 border-t-2 border-border">
                <div className="grid grid-cols-2 gap-4">
                  <div className="p-3 bg-gradient-card rounded-lg border border-success/20">
                    <label className="block text-sm font-semibold mb-2 text-success">Total Vendidas (valor €)</label>
                    <input
                      type="text"
                      value={
                        '€' + [1, 2, 3, 5, 10, 15].reduce((total, valor) => 
                          total + calcularTotalRasp(valor), 0
                        ).toFixed(2)
                      }
                      className="w-full px-3 py-2 border rounded-md bg-success/10 text-success font-bold text-xl cursor-not-allowed"
                      disabled
                      readOnly
                      title="Valor total das raspadinhas vendidas (soma de todos os Total €)"
                    />
                  </div>
                  
                  <div className="p-3 bg-gradient-card rounded-lg border border-primary/20">
                    <label className="block text-sm font-semibold mb-2 text-primary">Total Stock Final (valor €)</label>
                    <input
                      type="text"
                      value={
                        '€' + [1, 2, 3, 5, 10, 15].reduce((total, valor) => 
                          total + ((formData[`s_final_${valor}`] || 0) * valor), 0
                        ).toFixed(2)
                      }
                      className="w-full px-3 py-2 border rounded-md bg-primary/10 text-primary font-bold text-xl cursor-not-allowed"
                      disabled
                      readOnly
                      title="Valor total do stock final (S.Final × valor de cada raspadinha)"
                    />
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Prémios */}
          <Card>
            <CardContent className="pt-6">
              {/* Mesmos campos para Manhã e Tarde - 2 campos */}
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm mb-2">Vendas</label>
                  <input
                    type="text"
                    
                    value={formData.premios_master_1_15}
                    onChange={(e) => updateField('premios_master_1_15', e.target.value)}
                    onBlur={(e) => updateField('premios_master_1_15', parseFloat(e.target.value) || 0)}
                    className="w-full px-3 py-2 border rounded-md bg-background"
                    disabled={viewMode}
                    inputMode="decimal"
                    placeholder="0.00"
                  />
                </div>
                <div>
                  <label className="block text-sm mb-2">Prémios</label>
                  <input
                    type="text"
                    
                    value={formData.premios_total}
                    onChange={(e) => updateField('premios_total', e.target.value)}
                    onBlur={(e) => updateField('premios_total', parseFloat(e.target.value) || 0)}
                    className="w-full px-3 py-2 border rounded-md bg-background"
                    disabled={viewMode}
                    inputMode="decimal"
                    placeholder="0.00"
                  />
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Totais e Diferenças - mesmo para ambos os turnos */}
          <Card className="bg-gradient-card">
            <CardHeader><CardTitle className="text-base">Totais e Diferenças</CardTitle></CardHeader>
            <CardContent>
              {/* Mesmos 3 campos para Manhã e Tarde - calculados automaticamente */}
              <div className={`grid ${revendasDoTurno.length > 0 ? 'grid-cols-2 md:grid-cols-5' : 'grid-cols-3'} gap-4`}>
                <div>
                  <label className="block text-sm mb-2 font-semibold">Valor venda de raspadinhas</label>
                  <input
                    type="text"
                    value={
                      '€' + (() => {
                        // Total de raspadinhas vendidas em €
                        const totalVendidas = [1, 2, 3, 5, 10, 15].reduce((total, valor) => 
                          total + calcularTotalRasp(valor), 0
                        );
                        
                        return totalVendidas.toFixed(2);
                      })()
                    }
                    className="w-full px-3 py-2 border rounded-md bg-warning/10 text-warning font-bold cursor-not-allowed"
                    disabled
                    readOnly
                    title="Calculado: Total de raspadinhas vendidas em €"
                  />
                </div>
                <div>
                  <label className="block text-sm mb-2 font-semibold">Total expectável</label>
                  <input
                    type="text"
                    value={
                      '€' + (() => {
                        // Caixa Inicial + Total Vendidas + Vendas - Prémios
                        const caixaInicial = parseFloat(formData.caixa_inicial_1) || 0;
                        const totalVendidas = [1, 2, 3, 5, 10, 15].reduce((total, valor) => 
                          total + calcularTotalRasp(valor), 0
                        );
                        
                        let vendas = parseFloat(formData.premios_master_1_15) || 0;
                        let premios = parseFloat(formData.premios_total) || 0;
                        
                        // Se for Tarde e tiver dados da Manhã, SUBTRAIR vendas e prémios da manhã
                        if (formData.turno === 'Tarde' && dadosManha) {
                          const vendasManha = parseFloat(dadosManha.premios_master_1_15) || 0;
                          const premiosManha = parseFloat(dadosManha.premios_total) || 0;
                          vendas = vendas - vendasManha;
                          premios = premios - premiosManha;
                        }
                        
                        return (caixaInicial + totalVendidas + vendas - premios).toFixed(2);
                      })()
                    }
                    className="w-full px-3 py-2 border rounded-md bg-warning/10 text-warning font-bold cursor-not-allowed"
                    disabled
                    readOnly
                    title={formData.turno === 'Tarde' && dadosManha ? "Calculado: Caixa Inicial + Total Vendidas + (Vendas Tarde - Vendas Manhã) - (Prémios Tarde - Prémios Manhã)" : "Calculado: Caixa Inicial + Total Vendidas + Vendas - Prémios"}
                  />
                </div>
                <div>
                  <label className="block text-sm mb-2 font-semibold text-primary">Caixa Final</label>
                  <input
                    type="text"
                    value={'€' + (parseFloat(formData.caixa_inicial_2) || 0).toFixed(2)}
                    className="w-full px-3 py-2 border rounded-md bg-primary/10 text-primary font-bold cursor-not-allowed"
                    disabled
                    readOnly
                    title="Caixa Final = Caixa Real (Caixa Atual)"
                  />
                </div>
                {/* Diferença Real (apenas quando há revendas) */}
                {revendasDoTurno.length > 0 && (
                  <div>
                    <label className="block text-sm mb-2 font-semibold text-muted-foreground">Diferença Real</label>
                    <input
                      type="text"
                      value={
                        '€' + (() => {
                          // Caixa Atual - Total expectável (SEM ajustes)
                          const caixaInicial1 = parseFloat(formData.caixa_inicial_1) || 0;
                          const caixaInicial2 = parseFloat(formData.caixa_inicial_2) || 0;
                          
                          const totalVendidas = [1, 2, 3, 5, 10, 15].reduce((total, valor) => 
                            total + calcularTotalRasp(valor), 0
                          );
                          
                          let vendas = parseFloat(formData.premios_master_1_15) || 0;
                          let premios = parseFloat(formData.premios_total) || 0;
                          
                          // Se for Tarde e tiver dados da Manhã, SUBTRAIR vendas e prémios da manhã
                          if (formData.turno === 'Tarde' && dadosManha) {
                            const vendasManha = parseFloat(dadosManha.premios_master_1_15) || 0;
                            const premiosManha = parseFloat(dadosManha.premios_total) || 0;
                            vendas = vendas - vendasManha;
                            premios = premios - premiosManha;
                          }
                          
                          const totalExpectavel = caixaInicial1 + totalVendidas + vendas - premios;
                          const diferencaReal = caixaInicial2 - totalExpectavel;
                          const diferencaAjustada = Math.abs(diferencaReal) < 0.01 ? 0 : diferencaReal;
                          
                          return diferencaAjustada.toFixed(2);
                        })()
                      }
                      className="w-full px-3 py-2 border rounded-md bg-muted/10 text-muted-foreground font-bold cursor-not-allowed"
                      disabled
                      readOnly
                      title="Diferença Real: Caixa Real - Total expectável (sem ajustes de revendas)"
                    />
                  </div>
                )}
                
                <div>
                  <label className="block text-sm mb-2 font-semibold text-success">Diferença{revendasDoTurno.length > 0 ? ' Ajustada' : ''}</label>
                  {(() => {
                    // Caixa Atual - Total expectável
                    const caixaInicial1 = parseFloat(formData.caixa_inicial_1) || 0;
                    const caixaInicial2 = parseFloat(formData.caixa_inicial_2) || 0;
                    
                    const totalVendidas = [1, 2, 3, 5, 10, 15].reduce((total, valor) => 
                      total + calcularTotalRasp(valor), 0
                    );
                    
                    let vendas = parseFloat(formData.premios_master_1_15) || 0;
                    let premios = parseFloat(formData.premios_total) || 0;
                    
                    // Se for Tarde e tiver dados da Manhã, SUBTRAIR vendas e prémios da manhã
                    if (formData.turno === 'Tarde' && dadosManha) {
                      const vendasManha = parseFloat(dadosManha.premios_master_1_15) || 0;
                      const premiosManha = parseFloat(dadosManha.premios_total) || 0;
                      vendas = vendas - vendasManha;
                      premios = premios - premiosManha;
                    }
                    
                    const totalExpectavel = caixaInicial1 + totalVendidas + vendas - premios;
                    let diferenca = caixaInicial2 - totalExpectavel;
                    
                    // Ajustar pelo dinheiro de revendas (95% entra na caixa)
                    // O dinheiroRevendas AUMENTA o total expectável, logo DIMINUI a diferença
                    if (revendasDoTurno.length > 0) {
                      const dinheiroRevendas = revendasDoTurno.reduce((total, revenda) => {
                        const valorRaspadinhas = (
                          (revenda.raspadinha_1 || 0) * 1 +
                          (revenda.raspadinha_2 || 0) * 2 +
                          (revenda.raspadinha_3 || 0) * 3 +
                          (revenda.raspadinha_5 || 0) * 5 +
                          (revenda.raspadinha_10 || 0) * 10 +
                          (revenda.raspadinha_15 || 0) * 15
                        );
                        const comissaoRevendedor = valorRaspadinhas * 0.05;
                        const dinheiroLoja = valorRaspadinhas - comissaoRevendedor; // 95%
                        return total + dinheiroLoja;
                      }, 0);
                      
                      // SUBTRAIR: total expectável inclui revendas, logo diferença diminui
                      diferenca = diferenca - dinheiroRevendas;
                    }
                    
                    const diferencaAjustada = Math.abs(diferenca) < 0.01 ? 0 : diferenca;
                    const isZero = Math.abs(diferencaAjustada) < 0.01;
                    const isPositive = diferencaAjustada > 0;
                    
                    return (
                      <div className={`relative ${isZero ? 'animate-pulse' : ''}`}>
                        <input
                          type="text"
                          value={'€' + diferencaAjustada.toFixed(2)}
                          className={`w-full px-3 py-2 border-2 rounded-md font-bold text-xl cursor-not-allowed ${
                            isZero 
                              ? 'bg-green-100 border-green-500 text-green-700' 
                              : isPositive 
                                ? 'bg-blue-100 border-blue-500 text-blue-700'
                                : 'bg-red-100 border-red-500 text-red-700'
                          }`}
                          disabled
                          readOnly
                          title={revendasDoTurno.length > 0 ? "Calculado: (Caixa Real - Total expectável) - Ajuste de Revendas" : "Calculado: Caixa Real - Total expectável"}
                        />
                        {isZero && (
                          <div className="absolute -top-2 -right-2 bg-green-500 text-white text-xs px-2 py-1 rounded-full font-bold">
                            ✓ OK
                          </div>
                        )}
                        {!isZero && (
                          <div className={`absolute -top-2 -right-2 ${isPositive ? 'bg-blue-500' : 'bg-red-500'} text-white text-xs px-2 py-1 rounded-full font-bold`}>
                            {isPositive ? '↑ Sobra' : '↓ Falta'}
                          </div>
                        )}
                      </div>
                    );
                  })()}
                </div>
                
                {/* Aviso de revendas com detalhes */}
                {revendasDoTurno.length > 0 && (
                  <div className="col-span-full mt-4 p-4 bg-info/10 border border-info/30 rounded">
                    <div className="font-semibold mb-2 text-info flex items-center gap-2">
                      📦 Revendas Detectadas ({revendasDoTurno.length})
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
                      <div className="p-2 bg-white/50 rounded">
                        <div className="text-xs text-muted-foreground">Total Raspadinhas Revenda</div>
                        <div className="font-bold text-info">
                          €{revendasDoTurno.reduce((total, r) => 
                            total + 
                            (r.raspadinha_1 || 0) * 1 +
                            (r.raspadinha_2 || 0) * 2 +
                            (r.raspadinha_3 || 0) * 3 +
                            (r.raspadinha_5 || 0) * 5 +
                            (r.raspadinha_10 || 0) * 10 +
                            (r.raspadinha_15 || 0) * 15
                          , 0).toFixed(2)}
                        </div>
                      </div>
                      <div className="p-2 bg-white/50 rounded">
                        <div className="text-xs text-muted-foreground">Comissão (5%)</div>
                        <div className="font-bold text-warning">
                          -€{(revendasDoTurno.reduce((total, r) => 
                            total + 
                            (r.raspadinha_1 || 0) * 1 +
                            (r.raspadinha_2 || 0) * 2 +
                            (r.raspadinha_3 || 0) * 3 +
                            (r.raspadinha_5 || 0) * 5 +
                            (r.raspadinha_10 || 0) * 10 +
                            (r.raspadinha_15 || 0) * 15
                          , 0) * 0.05).toFixed(2)}
                        </div>
                      </div>
                      <div className="p-2 bg-white/50 rounded">
                        <div className="text-xs text-muted-foreground">Valor na Caixa (95%)</div>
                        <div className="font-bold text-success">
                          €{(revendasDoTurno.reduce((total, r) => 
                            total + 
                            (r.raspadinha_1 || 0) * 1 +
                            (r.raspadinha_2 || 0) * 2 +
                            (r.raspadinha_3 || 0) * 3 +
                            (r.raspadinha_5 || 0) * 5 +
                            (r.raspadinha_10 || 0) * 10 +
                            (r.raspadinha_15 || 0) * 15
                          , 0) * 0.95).toFixed(2)}
                        </div>
                      </div>
                      <div className="p-2 bg-success/20 rounded border border-success/30">
                        <div className="text-xs text-success font-semibold">Total para Objetivos</div>
                        <div className="font-bold text-success">
                          €{(
                            [1, 2, 3, 5, 10, 15].reduce((total, valor) => 
                              total + calcularTotalRasp(valor), 0
                            ) + 
                            revendasDoTurno.reduce((total, r) => 
                              total + 
                              (r.raspadinha_1 || 0) * 1 +
                              (r.raspadinha_2 || 0) * 2 +
                              (r.raspadinha_3 || 0) * 3 +
                              (r.raspadinha_5 || 0) * 5 +
                              (r.raspadinha_10 || 0) * 10 +
                              (r.raspadinha_15 || 0) * 15
                            , 0)
                          ).toFixed(2)}
                        </div>
                        <div className="text-xs text-success mt-1">Vendidas + Revenda</div>
                      </div>
                    </div>
                    
                    {/* RESUMO DO CÁLCULO COM REVENDAS */}
                    <div className="mt-4 p-3 bg-gradient-to-r from-blue-50 to-green-50 rounded-lg border-2 border-blue-200">
                      <div className="text-sm font-bold text-blue-800 mb-2">📊 RESUMO - Como a Diferença é Calculada:</div>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm">
                        <div className="space-y-1">
                          <div className="flex justify-between">
                            <span>Caixa Inicial:</span>
                            <span className="font-mono">€{(parseFloat(formData.caixa_inicial_1) || 0).toFixed(2)}</span>
                          </div>
                          <div className="flex justify-between">
                            <span>+ Vendas Raspadinhas:</span>
                            <span className="font-mono text-green-600">€{[1, 2, 3, 5, 10, 15].reduce((total, valor) => total + calcularTotalRasp(valor), 0).toFixed(2)}</span>
                          </div>
                          <div className="flex justify-between">
                            <span>+ Outras Vendas:</span>
                            <span className="font-mono">€{(parseFloat(formData.premios_master_1_15) || 0).toFixed(2)}</span>
                          </div>
                          <div className="flex justify-between">
                            <span>- Prémios Pagos:</span>
                            <span className="font-mono text-red-600">-€{(parseFloat(formData.premios_total) || 0).toFixed(2)}</span>
                          </div>
                          <div className="flex justify-between border-t pt-1 font-bold">
                            <span>= Total Expectável:</span>
                            <span className="font-mono">€{(() => {
                              const ci = parseFloat(formData.caixa_inicial_1) || 0;
                              const tv = [1, 2, 3, 5, 10, 15].reduce((t, v) => t + calcularTotalRasp(v), 0);
                              const ov = parseFloat(formData.premios_master_1_15) || 0;
                              const pp = parseFloat(formData.premios_total) || 0;
                              return (ci + tv + ov - pp).toFixed(2);
                            })()}</span>
                          </div>
                        </div>
                        <div className="space-y-1 border-l pl-3">
                          <div className="flex justify-between font-bold">
                            <span>Caixa Real (Final):</span>
                            <span className="font-mono">€{(parseFloat(formData.caixa_inicial_2) || 0).toFixed(2)}</span>
                          </div>
                          <div className="flex justify-between">
                            <span>Diferença Bruta:</span>
                            <span className="font-mono">{(() => {
                              const ci = parseFloat(formData.caixa_inicial_1) || 0;
                              const cf = parseFloat(formData.caixa_inicial_2) || 0;
                              const tv = [1, 2, 3, 5, 10, 15].reduce((t, v) => t + calcularTotalRasp(v), 0);
                              const ov = parseFloat(formData.premios_master_1_15) || 0;
                              const pp = parseFloat(formData.premios_total) || 0;
                              const te = ci + tv + ov - pp;
                              const diff = cf - te;
                              return (diff >= 0 ? '€' : '-€') + Math.abs(diff).toFixed(2);
                            })()}</span>
                          </div>
                          <div className="flex justify-between text-blue-600">
                            <span>+ Dinheiro Revenda (95%):</span>
                            <span className="font-mono">+€{(revendasDoTurno.reduce((total, r) => 
                              total + ((r.raspadinha_1 || 0) * 1 + (r.raspadinha_2 || 0) * 2 + (r.raspadinha_3 || 0) * 3 + (r.raspadinha_5 || 0) * 5 + (r.raspadinha_10 || 0) * 10 + (r.raspadinha_15 || 0) * 15)
                            , 0) * 0.95).toFixed(2)}</span>
                          </div>
                          <div className={`flex justify-between border-t pt-1 font-bold text-lg ${(() => {
                            const ci = parseFloat(formData.caixa_inicial_1) || 0;
                            const cf = parseFloat(formData.caixa_inicial_2) || 0;
                            const tv = [1, 2, 3, 5, 10, 15].reduce((t, v) => t + calcularTotalRasp(v), 0);
                            const ov = parseFloat(formData.premios_master_1_15) || 0;
                            const pp = parseFloat(formData.premios_total) || 0;
                            const te = ci + tv + ov - pp;
                            let diff = cf - te;
                            const dr = revendasDoTurno.reduce((total, r) => 
                              total + ((r.raspadinha_1 || 0) * 1 + (r.raspadinha_2 || 0) * 2 + (r.raspadinha_3 || 0) * 3 + (r.raspadinha_5 || 0) * 5 + (r.raspadinha_10 || 0) * 10 + (r.raspadinha_15 || 0) * 15)
                            , 0) * 0.95;
                            diff = diff + dr;
                            return Math.abs(diff) < 0.01 ? 'text-green-600' : diff > 0 ? 'text-blue-600' : 'text-red-600';
                          })()}`}>
                            <span>= DIFERENÇA FINAL:</span>
                            <span className="font-mono">{(() => {
                              const ci = parseFloat(formData.caixa_inicial_1) || 0;
                              const cf = parseFloat(formData.caixa_inicial_2) || 0;
                              const tv = [1, 2, 3, 5, 10, 15].reduce((t, v) => t + calcularTotalRasp(v), 0);
                              const ov = parseFloat(formData.premios_master_1_15) || 0;
                              const pp = parseFloat(formData.premios_total) || 0;
                              const te = ci + tv + ov - pp;
                              let diff = cf - te;
                              const dr = revendasDoTurno.reduce((total, r) => 
                                total + ((r.raspadinha_1 || 0) * 1 + (r.raspadinha_2 || 0) * 2 + (r.raspadinha_3 || 0) * 3 + (r.raspadinha_5 || 0) * 5 + (r.raspadinha_10 || 0) * 10 + (r.raspadinha_15 || 0) * 15)
                              , 0) * 0.95;
                              diff = diff + dr;
                              const final = Math.abs(diff) < 0.01 ? 0 : diff;
                              return (final >= 0 ? '€' : '-€') + Math.abs(final).toFixed(2) + (Math.abs(final) < 0.01 ? ' ✓' : '');
                            })()}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div className="text-xs text-muted-foreground mt-2">
                      💡 O total das raspadinhas vendidas + revendas conta para os pontos/objetivos do colaborador.
                    </div>
                  </div>
                )}
              </div>
              
              {/* Mostrar aviso SÓ DEPOIS da busca completar sem encontrar dados */}
              {formData.turno === 'Tarde' && !dadosManha && !loadingDadosManha && buscaCompleta && (
                <div className="mt-3 p-3 bg-warning/10 border border-warning/30 rounded text-sm text-warning">
                  <div className="font-semibold mb-1">⚠️ Atenção: Fecho do turno da Manhã não encontrado</div>
                  <div className="text-xs">
                    Para cálculos corretos do turno da Tarde, é necessário criar primeiro o fecho do turno da Manhã para a data <strong>{formData.data}</strong>.
                    Os cálculos atuais consideram apenas os valores da Tarde.
                  </div>
                </div>
              )}
              
              {/* Mostrar loading enquanto busca dados da Manhã */}
              {formData.turno === 'Tarde' && loadingDadosManha && (
                <div className="mt-3 p-3 bg-blue-50 border border-blue-200 rounded text-sm text-blue-700">
                  <div className="font-semibold">🔄 Carregando dados do turno da Manhã...</div>
                </div>
              )}
              
              {/* Mostrar info se for Tarde e tiver dados da Manhã */}
              {formData.turno === 'Tarde' && dadosManha && (
                <div className="mt-3 p-3 bg-success/10 border border-success/30 rounded text-sm text-success">
                  <div className="font-semibold mb-1">✓ Cálculos integrados com turno da Manhã</div>
                  <div className="text-xs">
                    Vendas da Manhã (-€{(dadosManha.premios_master_1_15 || 0).toFixed(2)}) + Prémios da Manhã (-€{(dadosManha.premios_total || 0).toFixed(2)}) 
                    são subtraídos automaticamente do Total expectável.
                  </div>
                </div>
              )}
            </CardContent>
          </Card>

          {/* Observações */}
          <div>
            <label className="block text-sm font-medium mb-2">Observações</label>
            <textarea
              value={formData.observacoes}
              onChange={(e) => updateField('observacoes', e.target.value)}
              className="w-full px-3 py-2 border rounded-md bg-background"
              rows={3}
              disabled={viewMode}
            />
          </div>

          <div className="flex justify-end gap-2 pt-4 border-t">
            <Button type="button" variant="outline" onClick={onClose}>
              {viewMode ? 'Fechar' : 'Cancelar'}
            </Button>
            {!viewMode && (
              <>
                {formData.turno === 'Tarde' && !dadosManha && !editingFecho && (
                  <div className="text-sm text-destructive mr-2 self-center">
                    ⚠️ Crie primeiro o fecho da Manhã
                  </div>
                )}
                <Button 
                  type="submit" 
                  className="bg-primary hover:bg-primary/90"
                  disabled={formData.turno === 'Tarde' && !dadosManha && !editingFecho}
                >
                  <Save className="h-4 w-4 mr-2" />
                  {editingFecho ? 'Atualizar' : 'Salvar'}
                </Button>
              </>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default FechoTurnoTab;
